/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataCenterDashboard
 */
export interface DataCenterDashboard {
    /**
     * 
     */
    omni_dashboard_id: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    description: string;
    /**
     * 
     */
    is_superadmin_only: boolean;
    /**
     * 
     */
    is_locked: boolean;
}

/**
 * Check if a given object implements the DataCenterDashboard interface.
 */
export function instanceOfDataCenterDashboard(value: object): value is DataCenterDashboard {
    if (!('omni_dashboard_id' in value) || value['omni_dashboard_id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('is_superadmin_only' in value) || value['is_superadmin_only'] === undefined) return false;
    if (!('is_locked' in value) || value['is_locked'] === undefined) return false;
    return true;
}

export function DataCenterDashboardFromJSON(json: any): DataCenterDashboard {
    return DataCenterDashboardFromJSONTyped(json, false);
}

export function DataCenterDashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataCenterDashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'omni_dashboard_id': json['omni_dashboard_id'],
        'title': json['title'],
        'description': json['description'],
        'is_superadmin_only': json['is_superadmin_only'],
        'is_locked': json['is_locked'],
    };
}

export function DataCenterDashboardToJSON(json: any): DataCenterDashboard {
    return DataCenterDashboardToJSONTyped(json, false);
}

export function DataCenterDashboardToJSONTyped(value?: DataCenterDashboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'omni_dashboard_id': value['omni_dashboard_id'],
        'title': value['title'],
        'description': value['description'],
        'is_superadmin_only': value['is_superadmin_only'],
        'is_locked': value['is_locked'],
    };
}

